import { useParams } from "react-router-dom"

import { useQuery } from "@tanstack/react-query"
import axios from "axios"

import { RegistrationData } from "types"

export const useRegistrationData = () => {
  const { uuid } = useParams<{ uuid: string }>()

  const {
    data: registrationData,
    isLoading,
    error,
    refetch: refetchRegistrationData,
  } = useQuery<RegistrationData>({
    queryKey: ["registration", uuid],
    queryFn: async () => {
      if (!uuid) throw new Error("UUID is required")
      const response = await axios.get(`/api/registration/${uuid}/`)
      return response.data
    },
    enabled: !!uuid,
    retry: 3,
    staleTime: 5 * 60 * 1000, // 5 minutes
  })

  return {
    // Raw data (industry best practice: provide both raw data and extracted fields)
    registrationData,

    // Extracted fields for convenience
    registrationId: registrationData?.registrationId,
    bundleUUID: registrationData?.bundleUUID,
    ticketGroup: registrationData?.ticketGroup,
    guideId: registrationData?.guideId,
    owner_id: registrationData?.owner_id,
    guideIconUrl: registrationData?.guide_icon_url,
    isLive: registrationData?.is_live ?? false,
    stripeConnectedAccountId: registrationData?.stripe_connected_account_id,

    // Advanced forms flag with default
    isAdvancedFormsEnabled: !!registrationData?.using_advanced_forms,

    // Query state
    isLoading,
    error,
    refetchRegistrationData,
  }
}
